import React, { Component, ErrorInfo, ReactNode } from "react";

import { Alert, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import SaveButton from "./SaveButton";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Grid
          container
          component={Paper}
          justifyContent="center"
          alignItems="center"
          sx={{ margin: "0 auto", width: "40vw", p: 5, mt: "20vh" }}
        >
          <Stack gap={3}>
            <Alert severity={"error"} sx={{ m: "auto" }}>
              Something went wrong! Try refreshing the page.
            </Alert>
            <SaveButton
              variant="contained"
              color="primary"
              sx={{ minWidth: 300 }}
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </SaveButton>
          </Stack>
        </Grid>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
